import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { AppDownload, Footer, Header, WhyRush } from "../components";

const IndividualsPage = () => {
  return (
    <>
      <Header />
      <Wrapper>
        <div className="individuals">
          <div className="individuals__row">
            <div className="indi_header_com">
              <h5 className="indi__header_h5">
                on-demand delivery for individuals
              </h5>
              <h1 className="indi__header_h1">
                Reliable deliveries in your locality
              </h1>

              <div className="indi__header_p">
                <p>
                  Wecanrush enables individuals send important items from their
                  current location to the desired location in real-time.
                </p>
              </div>
              <div className="indi__btn">
                <Link
                  onClick={() =>
                    window.open("https://app.wecanrush.com/register", "_blank")
                  }
                >
                  <div className="indi__first_btn">
                    <button>Create a free account</button>
                  </div>
                </Link>

                <Link to="/">
                  <div className="indi__secend_btn">
                    <button>Get Estimate</button>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="svgMain">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
            <path
              fill="#E5EDFC"
              fill-opacity="1"
              d="M0,320L1440,64L1440,0L0,0Z"
            ></path>
          </svg>
        </div>
        <WhyRush />
        <AppDownload />
        <Footer />
      </Wrapper>
    </>
  );
};

const Wrapper = styled.div`
  width: 100% !important;

  .svgMain {
    margin: -80px;
  }
  .individuals {
    background-color: #e2edfc;
    width: 100% !important;
    padding-bottom: 17px !important;
    .individuals__row {
      width: var(--max-width);
      margin: 0 auto;
      .indi_header_com {
        padding: 92px 0;
        width: 517px;
        .indi__header_h5 {
          font-family: Manrope;
          font-style: normal;
          font-weight: 600;
          font-size: 14px;
          line-height: 46px;
          text-transform: uppercase;
          color: #455880;
        }

        .indi__header_h1 {
          font-family: Gilroy;
          font-style: normal;
          font-weight: 800;
          font-size: 54px;
          line-height: 72px;
          color: #6300ff;
        }
        .indi__header_p {
          padding: 0;
          p {
            font-family: "Manrope";
            font-style: normal;
            font-weight: 500;
            font-size: 18px;
            line-height: 38px;
            width: 550px;
            margin-top: 20px;
            letter-spacing: 0.3px;
            color: #455880;
          }
        }
        .indi__btn {
          display: flex;
          align-items: center;
          margin-top: 107px;
          .indi__first_btn button {
            background: #1d66ff;
            box-shadow: 0px 2px 4px rgba(0, 16, 75, 0.2);
            border-radius: 5px;
            font-family: Manrope;
            font-style: normal;
            font-weight: 500;
            font-size: 16px;
            line-height: 22px;
            color: #ffffff;
            width: 232px;
            height: 56px;
            border: none;
            outline: none;
          }
          .indi__secend_btn button {
            background: linear-gradient(
              110.57deg,
              rgba(229, 237, 252, 0.1) -2.17%,
              #e5edfc 99.02%
            );

            font-family: Manrope;
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 22px;
            color: #1d66ff;
            width: 165px;
            height: 56px;
            margin-left: 20px;
            border-radius: 5px;
            border: none;
            outline: none;
            transition: 0.3s;
            letter-spacing: 0.7px;
          }
          .indi__secend_btn button:hover {
            background: #1d66ff;
            color: #fff;
          }
        }
      }
    }
  }
  @media screen and (max-width: 440px) {
    .rush__top p {
      font-size: 14px !important;
      line-height: 19px !important;
      text-align: center !important;
      width: 100% !important;
    }
    .individuals
      .individuals__row
      .indi_header_com
      .indi__btn
      .indi__first_btn {
      border-radius: 5px;
      font-family: Manrope;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 19px;
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-align-items: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      color: #ffffff;
      border: none;
      outline: none;
      button {
        background: #1d66ff;
        box-shadow: 0px 2px 4px rgba(0, 16, 75, 0.2);
        border-radius: 5px;
        font-family: Manrope;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 22px;
        color: #ffffff;
        width: 100% !important;
        height: 56px;
        border: none;
        outline: none;
        padding: 0 15px;
      }
    }
    .indi__header_p p {
      font-family: "Manrope";
      font-style: normal;
      font-weight: 500;
      font-size: 20px;
      line-height: 38px;
      width: 100% !important;
      margin-top: 20px;
      -webkit-letter-spacing: 0.3px;
      -moz-letter-spacing: 0.3px;
      -ms-letter-spacing: 0.3px;
      letter-spacing: 0.3px;
    }
    .indi_header_com {
      padding: 169px 20px !important;
      overflow: hidden;
      width: 100% !important;
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-flex-direction: column;
      -ms-flex-direction: column;
      flex-direction: column;
    }
    .single__rush {
      width: 340px !important;
      border-radius: 15px !important;
      box-shadow: 0px 0px 50px 0px #e7f5ff !important;
      box-sizing: border-box !important;
      padding: 15px !important;
      margin-left: 28px;
      text-align: left;
    }
    .industries__header p {
      font-family: Manrope;
      font-style: normal;
      font-weight: 500;
      font-size: 17px;
      line-height: 30px;
      -webkit-align-items: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      text-align: center;
      color: #777e91;
      margin-top: 20px !important;
      width: 100% !important;
    }
    .svgMain {
      margin: 0;
    }
  }
  @media screen and (max-width: 768px) {
    .individuals {
      background-color: #e2edfc;
      width: 100% !important;
      .individuals__row {
        width: var(--max-width);
        margin: 0 auto;
        width: 100% !important;
        .indi_header_com {
          padding: 169px 50px;
          width: 600px;
          display: flex;
          flex-direction: column;
          .indi__header_h5 {
            font-family: Manrope;
            font-style: normal;
            font-weight: 600;
            font-size: 12px;
            line-height: 46px;
            display: flex;
            align-items: center;
            text-transform: uppercase;
            color: #455880;
          }
          .indi__header_h1 {
            font-family: Gilroy;
            font-style: normal;
            font-weight: 800;
            font-size: 36px;
            line-height: 50px;
            color: #6300ff;
          }
          .indi__header_p {
            p {
              font-family: Manrope;
              font-style: normal;
              font-weight: 500;
              font-size: 16px;
              line-height: 30px;
              color: #455880;
            }
          }
          .indi__btn {
            display: flex;

            .indi__first_btn {
              border-radius: 5px;
              font-family: Manrope;
              font-style: normal;
              font-weight: 500;
              font-size: 14px;
              line-height: 19px;
              display: flex;
              align-items: center;
              color: #ffffff;
              border: none;
              outline: none;
            }
            .indi__secend_btn {
              background: transparent;
              font-family: Manrope;
              font-style: normal;
              font-weight: 600;
              font-size: 14px;
              line-height: 19px;
              display: flex;
              align-items: center;
              color: #1d66ff;
              border: none;
              outline: none;
              margin: 0;
            }
          }
        }
      }
    }
  }
`;

export default IndividualsPage;
